import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveIdeaPopupComponent } from './save-idea-popup.component';
import { SharedModule } from '../../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';



@NgModule({
  declarations: [
    SaveIdeaPopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,CheckboxModule,ScrollPanelModule,SidebarModule
  ],
  exports:[SaveIdeaPopupComponent]
})
export class SaveIdeaPopupModule { }
